import { render, staticRenderFns } from "./copySearchTable.vue?vue&type=template&id=63badcb2"
import script from "./copySearchTable.vue?vue&type=script&lang=js"
export * from "./copySearchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports